import { render } from "./reset_password.html?vue&type=template&id=aa35a268&external"
import script from "./reset_password.js?vue&type=script&lang=js&external"
export * from "./reset_password.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__